import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientListEntity } from './client-list.entity';
import { ClientEntity } from './client.entity';

@Index('idx_client_list__client_client', ['fkClientId'], {})
@Index('idx_client_list__client_deleted', ['deletedDate'], {})
@Index('idx_client_list__client_list', ['fkClientListId'], {})
@Index('idx_client_list__client_unique', ['fkClientListId', 'fkClientId'], {
	unique: true,
})
@Entity('client_list__client')
export class ClientListClientEntity extends BaseEntity {
	@Column('int', { name: '_fk_client_list__id', unsigned: true })
	public fkClientListId!: number;

	@Column('int', { name: '_fk_client__id', unsigned: true })
	public fkClientId!: number;

	@ManyToOne(() => ClientEntity, (client) => client.clientListClients, {
		onDelete: 'CASCADE',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;

	@ManyToOne(
		() => ClientListEntity,
		(clientList) => clientList.clientListClients,
		{
			onDelete: 'CASCADE',
			onUpdate: 'NO ACTION',
		},
	)
	@JoinColumn([{ name: '_fk_client_list__id', referencedColumnName: 'id' }])
	public fkClientList!: ClientListEntity;
}
